export type ActionBarProps = {
  children?: React.ReactNode;
  id?: string;
};

export const ActionBar = ({ children, id = '' }: ActionBarProps) => {
  return (
    <div
      className="h-20 w-full bg-[#004DBC]"
      data-testid={`actionBar-component--${id}`}
      id={id}
      style={{ display: 'grid', gridTemplateColumns: 'auto auto', justifyContent: 'space-between' }}
    >
      {children}
    </div>
  );
};
